import createIcon from '../../createIcon';

/**
 * @component @name HideImage
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjEuNzA5NiA0LjI4OTYxQzIxLjcwOTYgMy4xODk2MSAyMC44MDk2IDIuMjg5NjEgMTkuNzA5NiAyLjI4OTYxSDYuNTM5NjFMMjEuNzA5NiAxNy40NTk2VjQuMjg5NjFaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMy41MTk2MSAyLjA5OTYxTDIuMDk5NjEgMy41MDk2MUwzLjcwOTYxIDUuMTE5NjFWMTguMjg5NkMzLjcwOTYxIDE5LjM4OTYgNC42MDk2MSAyMC4yODk2IDUuNzA5NjEgMjAuMjg5NkgxOC44Nzk2TDIwLjQ4OTYgMjEuODk5NkwyMS44OTk2IDIwLjQ4OTZMMy41MTk2MSAyLjA5OTYxWk02LjcwOTYxIDE2LjI4OTZMOS43MDk2MSAxMi4yODk2TDExLjk1OTYgMTUuMjg5NkwxMi43Nzk2IDE0LjE4OTZMMTQuODc5NiAxNi4yODk2SDYuNzA5NjFaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const HideImage = createIcon('HideImage', [
  [
    'path',
    {
      d: 'M21.7096 4.28961C21.7096 3.18961 20.8096 2.28961 19.7096 2.28961H6.53961L21.7096 17.4596V4.28961Z',
      key: 'wi56we',
    },
  ],
  [
    'path',
    {
      d: 'M3.51961 2.09961L2.09961 3.50961L3.70961 5.11961V18.2896C3.70961 19.3896 4.60961 20.2896 5.70961 20.2896H18.8796L20.4896 21.8996L21.8996 20.4896L3.51961 2.09961ZM6.70961 16.2896L9.70961 12.2896L11.9596 15.2896L12.7796 14.1896L14.8796 16.2896H6.70961Z',
      key: 'i4gfbm',
    },
  ],
]);

export default HideImage;
